import React, { FC, useCallback } from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { OpenRightPanel } from "types/common/rightPanel";
import { openRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import { setSelectedExpectedItemId } from "../../../../reduxFolder/reducers/storage";
import { panelSelectOpened } from "../../../../reduxFolder/selectors/rightPanelSelectors";
import {
  selectedExpectedItemId,
  storageSelectExpectedShops,
} from "../../../../reduxFolder/selectors/storageSelectors";
import { demoExpectedItems } from "../../../Storage/components/DemoShipments/demoFixtures";
import DemoFrame from "../../../Storage/components/DemoShipments/DemoFrame";
import { FadeWrapper } from "../../../Storage/components/DemoShipments/DemoShipments.styles";
import ExpectedItemRow from "../ExpectedList/ExpectedItemRow";
import { Wrapper } from "../ExpectedList/ExpectedList.styles";

interface DemoExpectedItemsProps {
  shops: any;
  selectedExpectedItemId: string | null;
  isPanelOpened: boolean;
  openRightPanel: OpenRightPanel;
  setSelectedExpectedItemId: (id: string | null) => void;
}

// Sample rows for a settled-empty Expected list. The panel is form-driven off
// panelData, so no detail cache needs seeding — isDemo alone flips it into
// browse-only mode (save/remove hint, customs read-only, no fetches).
const DemoExpectedItems: FC<DemoExpectedItemsProps> = ({
  shops,
  selectedExpectedItemId: selectedItemId,
  isPanelOpened,
  openRightPanel,
  setSelectedExpectedItemId,
}) => {
  const { t } = useTranslation("common");

  const handleFocusExpectedItemInPanel = useCallback(
    (parcel: any) => {
      setSelectedExpectedItemId(parcel.get("id"));
      openRightPanel(
        "EXPECTED_ITEM",
        Map({
          selectedExpectedItem: parcel,
          isEditForm: true,
          isDemo: true,
        }).merge(parcel),
      );
    },
    [openRightPanel, setSelectedExpectedItemId],
  );

  return (
    <DemoFrame
      title={t("parcels.demo.expectedTitle")}
      subtitle={t("parcels.demo.expectedSubtitle")}
    >
      <FadeWrapper>
        <Wrapper>
          {demoExpectedItems.map((parcel: any) => (
            <ExpectedItemRow
              key={parcel.get("id")}
              parcel={parcel}
              selectedParcel={selectedItemId}
              onFocusExpectedItemInPanel={handleFocusExpectedItemInPanel}
              disabled={false}
              shops={shops}
              isPanelOpened={isPanelOpened}
              isDemo
            />
          ))}
        </Wrapper>
      </FadeWrapper>
    </DemoFrame>
  );
};

const withConnect = connect(
  createStructuredSelector({
    shops: storageSelectExpectedShops,
    selectedExpectedItemId,
    isPanelOpened: panelSelectOpened,
  }),
  {
    openRightPanel,
    setSelectedExpectedItemId,
  },
);

export default withConnect(DemoExpectedItems);
